// Generated by scripts/build-ui-icons.mjs.
export { Package as default } from "../ui/glyphs-5";
